/*
  Captain Stone Crab cart extras (561 Media, 2026-10-22)
  - Insurify: on by default. One unit on the right price tier whenever the cart
    has products; removed when the cart has nothing else. Unchecking keeps it
    off (cart attribute Insurance-Removed = yes) until the customer checks it again.
  - Gift option: "This is a gift" + message, saved as cart attributes
    Gift / Gift Message so they show on the order in Shopify admin.
  The drawer and cart page HTML is re-rendered by theme.js (innerHTML), so this
  file uses delegated events and a MutationObserver.
*/
(function () {
  if (window.__cscCartExtras) return;
  window.__cscCartExtras = true;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }

  // ---- Insurify rule (same on CSC and SCW) ----
  // Exactly one Insurify unit, on the tier that matches the cart subtotal,
  // whenever the cart has real products and the customer has not unchecked it.
  // Unchecking sets cart attribute Insurance-Removed = yes; checking clears it.
  function insurifyTiers() {
    var el = document.getElementById('insurify-tiers');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent).map(function (v) {
        return { id: v.id, max: Math.round(parseFloat(String(v.t).split('-').pop()) * 100) };
      }).filter(function (v) { return !isNaN(v.max); }).sort(function (a, b) { return a.max - b.max; });
    } catch (e) { return []; }
  }

  function insurifyPlan(cart, forceOn) {
    var tiers = insurifyTiers();
    if (!tiers.length) return null;
    var ids = tiers.map(function (t) { return t.id; });
    var insLines = cart.items.filter(function (i) { return ids.indexOf(i.variant_id) > -1; });
    var real = cart.items.filter(function (i) { return ids.indexOf(i.variant_id) === -1; });
    var subtotal = real.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var optedOut = !forceOn && (cart.attributes || {})['Insurance-Removed'] === 'yes';
    var tier = null;
    for (var k = 0; k < tiers.length; k++) { if (subtotal <= tiers[k].max) { tier = tiers[k]; break; } }
    var wantId = (real.length && !optedOut && tier) ? tier.id : 0;

    var updates = {};
    var changed = false;
    var have = {};
    insLines.forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
    Object.keys(have).forEach(function (id) {
      var want = (+id === wantId) ? 1 : 0;
      if (have[id] !== want) { updates[id] = want; changed = true; }
    });
    if (wantId && !have[wantId]) { updates[wantId] = 1; changed = true; }
    return { changed: changed, updates: updates, on: !!wantId };
  }

  function refreshCart(cart) {
    var cfgEl = document.getElementById('cart-config');
    if (!cfgEl || !window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart) return;
    Shopify.theme.ajaxCart.updateView(JSON.parse(cfgEl.innerHTML || '{}'), cart);
  }

  var busy = false;
  var recent = []; // loop guard: at most 4 automatic fixes per 10 seconds
  function syncInsurance(extraAttrs, forceOn) {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var plan = insurifyPlan(cart, forceOn);
      if (!plan) return;
      var now = Date.now();
      recent = recent.filter(function (t) { return now - t < 10000; });
      if (!extraAttrs && (!plan.changed || recent.length >= 4)) return;
      recent.push(now);
      var body = { updates: plan.updates };
      if (extraAttrs) body.attributes = extraAttrs;
      return post('/cart/update.js', body).then(refreshCart);
    }).catch(function (e) { console.log('Insurify', e); })
      .then(function () { busy = false; });
  }

  // Checkbox in snippets/cart-form.liquid calls this on change
  window.manageInsurify = function () {
    var box = document.getElementById('insurance-checkbox');
    if (!box) return;
    if (box.checked) syncInsurance({ 'Insurance-Removed': '' }, true);
    else {
      busy = true;
      getCart().then(function (cart) {
        var plan = insurifyPlan({ items: cart.items, attributes: { 'Insurance-Removed': 'yes' } });
        return post('/cart/update.js', { updates: plan ? plan.updates : {}, attributes: { 'Insurance-Removed': 'yes' } });
      }).then(refreshCart).catch(function (e) { console.log('Insurify', e); })
        .then(function () { busy = false; });
    }
  };

  // Gift option
  var giftTimer = null;
  function saveGift(on, message) {
    return post('/cart/update.js', {
      attributes: { 'Gift': on ? 'Yes' : '', 'Gift Message': on ? message : '' }
    }).catch(function (e) { console.log('Gift save', e); });
  }
  function giftParts(el) {
    var wrap = el.closest('.js-cart-gift');
    return {
      toggle: wrap.querySelector('.js-cart-gift-toggle'),
      value: wrap.querySelector('.js-cart-gift-value'),
      panel: wrap.querySelector('.js-cart-gift-message'),
      text: wrap.querySelector('.js-cart-gift-text'),
      count: wrap.querySelector('.js-cart-gift-count')
    };
  }
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('js-cart-gift-toggle')) return;
    var g = giftParts(e.target);
    var on = g.toggle.checked;
    g.value.value = on ? 'Yes' : '';
    g.panel.hidden = !on;
    if (on) g.text.focus();
    saveGift(on, g.text.value);
  });
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('js-cart-gift-text')) return;
    var g = giftParts(e.target);
    if (g.count) g.count.textContent = g.text.value.length;
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () { saveGift(g.toggle.checked, g.text.value); }, 400);
  });

  // Check the Insurify rule every time the cart HTML is re-rendered
  function watch() {
    var timer = null;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { syncInsurance(); }, 250);
    });
    document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
      obs.observe(el, { childList: true });
    });
    syncInsurance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
